// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YO81","footer":"styles_footer__2Ohu5"};